import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../services/login.service';
import { Observable, BehaviorSubject, throwError, from } from 'rxjs';
import { filter, take, switchMap, catchError, flatMap, tap, mergeMap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  constructor(public loginService: LoginService, private router: Router, private toastr: ToastrService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return <any>next.handle(request).pipe(
      catchError<HttpEvent<any>, any>((error: HttpErrorResponse) => {
        // Client side blocking either connection issue or client script is blocked
        
        //error = new HttpErrorResponse({status: 401});
        if (error.status === 0) {
          // Replace error to serve a service unavailable
          error = new HttpErrorResponse({status: 503});
          if (!(request.url.toLocaleLowerCase().indexOf('token') > -1)) {
            this.toastr.error(
              'Service is uncontactable, click here to return to login screen or close and retry.',
              '',
              {
                closeButton: true,
                timeOut: 5000,
                extendedTimeOut: 2000,
                progressBar: true
              })
              .onTap
              .pipe(
                take(1),
                tap(() => {
                  this.loginService.Logout();
                  this.router.navigate(['/login']);
                })
                )
              .subscribe();
          }

          return throwError(error);
        }

        if (request.url.toLocaleLowerCase().indexOf('authentication/refreshtoken') > -1 ||
            request.url.toLocaleLowerCase().indexOf('authentication') > -1) {
        
          if (request.url.toLocaleLowerCase().indexOf('authentication/refreshtoken') > -1) {
            this.loginService.Logout();
            this.router.navigate(['/login']);
          }

          return throwError(error);
        }

        
        if (error.status !== 401) {
         
          return throwError(error);
        }
       
        return from(this.loginService.getAccessTokenPromise()).pipe(
          take(1),
          map(token => request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })),
          mergeMap((newRequest) => next.handle(newRequest)
        ));

      }));
  }
}
